import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPublicJobDetail } from "./publicJobDescriptionAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchPublicJobDetailAsync = createAsyncThunk(
  "JobDetail/fetch",
  async ({uuid}, { rejectWithValue }) => {
    try {
      const data = await fetchPublicJobDetail(uuid);

      const resp = data?.response;
      // console.log("api", data)
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PublicJobDetailSlice = createSlice({
  name: "PublicJobDetail",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicJobDetailAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPublicJobDetailAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchPublicJobDetailAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectPublicJobDetail = (state) => state.publicJobDetail.data;

export default PublicJobDetailSlice.reducer;
